const TrustBar = () => {
  const items = [
    '5-Star Rated Studio',
    'Art Classes for All Ages',
    'Birthday Parties',
    'Private Events',
    'Kids & Adults Welcome',
    'Nazareth, PA',
    'All Supplies Included',
    'Gift Cards Available',
    'Beginner-Friendly',
    'Guided by Kelsey',
  ];

  return (
    <section className="relative py-4 overflow-hidden" style={{ background: '#0e0e0e' }}>
      {/* Top paint line */}
      <div className="absolute top-0 left-0 right-0 h-[2px]" style={{ background: 'linear-gradient(90deg, #ff4322, #ffb300, #ff7120, #e0285a, #ff4322)' }} />
      <div className="absolute bottom-0 left-0 right-0 h-[2px]" style={{ background: 'linear-gradient(90deg, #ff4322, #ffb300, #ff7120, #e0285a, #ff4322)' }} />

      {/* Marquee */}
      <div className="flex items-center gap-0 overflow-hidden">
        <div className="flex items-center gap-0 marquee-track whitespace-nowrap">
          {[...items, ...items, ...items, ...items].map((item, i) => (
            <span key={i} className="inline-flex items-center gap-3 px-8">
              <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: ['#ff4322', '#ffb300', '#ff7120', '#e0285a'][i % 4] }} />
              <span className="font-outfit text-white/55 text-sm font-medium tracking-wide">{item}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
